<template>
  <v-dialog v-model="downloading" hide-overlay fullscreen>
    <!-- <v-dialog v-model="downloading" hide-overlay> -->
    <div style="position: absolute; z-index: -1">
      <img id="mapImg" width="600" height="600" />
    </div>
    <v-card tile elevation="0">
      <div class="progress">
        <v-progress-circular
          :size="210"
          :width="2"
          color="#51627C"
          indeterminate
        >
          Generating Document
        </v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from "@/mixins/FormatDate";
import {
  // eslint-disable-next-line no-unused-vars
  AlignmentType,
  // eslint-disable-next-line no-unused-vars
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  // eslint-disable-next-line no-unused-vars
  TabStopPosition,
  // eslint-disable-next-line no-unused-vars
  TabStopType,
  // eslint-disable-next-line no-unused-vars
  TextRun,
  ImageRun,
  PageOrientation,
  // eslint-disable-next-line no-unused-vars
  ShadingType,
  Table,
  TableCell,
  TableRow,
  // eslint-disable-next-line no-unused-vars
  WidthType,
  // eslint-disable-next-line no-unused-vars
  VerticalAlign,
  // eslint-disable-next-line no-unused-vars
  convertInchesToTwip,
  // eslint-disable-next-line no-unused-vars
  BorderStyle,
  // eslint-disable-next-line no-unused-vars
  HorizontalPositionRelativeFrom,
  // eslint-disable-next-line no-unused-vars
  TextDirection,
  HeightRule,
  Footer,
  // eslint-disable-next-line no-unused-vars
  HorizontalPositionAlign,
  // eslint-disable-next-line no-unused-vars
  VerticalPositionAlign,
  NumberFormat,
  PageNumber,
  ExternalHyperlink,
  // eslint-disable-next-line no-unused-vars
  TableOfContents,
  // eslint-disable-next-line no-unused-vars
  StyleLevel,
  Bookmark,
  InternalHyperlink,
  // eslint-disable-next-line no-unused-vars
  PageReference,
  UnderlineType,
  LevelFormat,
  // eslint-disable-next-line no-unused-vars
  Header,
  // eslint-disable-next-line no-unused-vars
  Numbering,
} from "docx";
// eslint-disable-next-line no-unused-vars

import { saveAs } from "file-saver";
import { useDisplay } from "vuetify";
// import { link } from "fs";

export default {
  name: "DOCX",
  data: () => ({
    screenWidth: useDisplay().width,
    timeStamp: null,
    wordDocument: null,
    pageOrientation: "LANDSCAPE",
    sectionTemplate: null,
    mapDataURL: null,
    topLeftLogo:
      "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",
    noCellBorders: {
      top: {
        style: BorderStyle.NONE,
        size: 0,
        color: "#000000",
      },
      bottom: {
        style: BorderStyle.NONE,
        size: 0,
        color: "#000000",
      },
      left: {
        style: BorderStyle.NONE,
        size: 0,
        color: "#000000",
      },
      right: {
        style: BorderStyle.NONE,
        size: 0,
        color: "#000000",
      },
    },
    noCellMargins: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  }),
  components: {},
  props: {
    mapImage: null,
    isReportManager: null,
    content: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    download: {
      type: Boolean,
      required: true,
      default: false,
    },
    reportMapPrimaryAreaCode: null,
    indicatorValues: {
      type: Object,
      default() {
        return {};
      },
    },
    comparators: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    comparatorsList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  computed: {
    includeAppendix: {
      get() {
        return this.$store.state.config.customClientConfig
          .add_appendix_to_report_doc;
      },
    },
    reportID: {
      get() {
        return this.$store.state.reportID;
      },
      set(value) {
        this.$store.commit("setReportID", value);
      },
    },
    selectedThemes: {
      get() {
        return this.$store.state.selectedThemes;
      },
      set(value) {
        this.$store.commit("setSelectedThemes", value);
      },
    },
    topRightLogo() {
      if (this.content.reportLogo) {
        return this.content.reportLogo.split(",")[1];
      } else {
        return "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";
      }
    },
    chartsWidth: {
      get() {
        if (this.pageOrientation === "LANDSCAPE") {
          return 955;
        } else {
          return 775.18110236;
        }
      },
    },
    // anything smaller than 400 looks squashed :/
    chartsHeight: {
      get() {
        if (this.pageOrientation === "LANDSCAPE") {
          return 360.87401575;
        } else {
          return 399.87401575;
        }
      },
    },
    tableWidth: {
      get() {
        if (this.pageOrientation === "LANDSCAPE") {
          return 14320;
        } else {
          return 775.18110236;
        }
      },
    },
    margins: {
      get() {
        if (this.pageOrientation === "LANDSCAPE") {
          return 1270;
        } else {
          return 1270;
        }
      },
    },
    downloading: {
      get() {
        return this.download;
      },
      set(val) {
        this.$emit("update:download", val);
      },
    },
  },
  mounted() {
    this.sectionTemplate = {
      properties: {
        page: {
          size: {
            orientation: PageOrientation[this.pageOrientation],
          },
          margin: {
            top: this.margins,
            right: this.margins,
            bottom: this.margins,
            left: this.margins,
          },
        },
        orientation: PageOrientation.LANDSCAPE,
        pageNumbers: {
          start: 1,
          formatType: NumberFormat.DECIMAL,
        },
      },
      children: [],
      footers: {
        default: new Footer({
          children: [
            new Paragraph({
              text: "Oxford Consultants for Social Inclusion Ltd. All rights reserved.",
              style: "footerText",
            }),
            new Paragraph({
              text:
                "Copyright © " +
                new Date().getFullYear() +
                ". Not to be used for commercial purposes.",
              style: "footerText",
            }),
            new Paragraph({
              alignment: AlignmentType.RIGHT,
              children: [
                new TextRun({
                  children: ["Page ", PageNumber.CURRENT],
                }),
                new TextRun({
                  children: [" of ", PageNumber.TOTAL_PAGES],
                }),
              ],
            }),
          ],
        }),
      },
    };
  },
  methods: {
    sendAnalytics() {
      this.$axios.put("/send-analytics", {
        event: "reports_download",
        reportID: this.reportID,
        summary: this.selectedThemes.length ? false : true,
        c1: {
          areaName: this.comparatorsList[0].area_name,
          areaCode: this.comparatorsList[0].area_code,
        },
        c2: {
          areaName: this.comparatorsList[1].area_name,
          areaCode: this.comparatorsList[1].area_code,
        },
        c3: {
          areaName: this.comparatorsList[2].area_name,
          areaCode: this.comparatorsList[2].area_code,
        },
        themes: this.selectedThemes,
        moduleName: "Reports",
        pageName: "Reports",
      });
    },
    columnHeaderText(text, style = null) {
      return new Paragraph({
        text: text,
        style: style ? style : "tableHeader",
        alignment: AlignmentType.CENTER,
      });
    },
    getStandardTableData(comparator, indicator, indicators) {
      let text = "-";
      if (
        this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName)
        ] !== null
      ) {
        text =
          this.indicatorValues[
            this.comparators[comparator] +
              "." +
              indicators[indicator].indicatorCode +
              "." +
              indicators[indicator].date +
              "." +
              (indicators[indicator].use_short_indicator_name &&
              indicators[indicator].shortName !== null
                ? indicators[indicator].shortName
                : indicators[indicator].indicatorName)
          ].toString();
      }
      let rate = "-";
      if (
        typeof this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName) +
            ".rate"
        ] !== "undefined" &&
        this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName) +
            ".rate"
        ] !== null
      ) {
        rate =
          this.indicatorValues[
            this.comparators[comparator] +
              "." +
              indicators[indicator].indicatorCode +
              "." +
              indicators[indicator].date +
              "." +
              (indicators[indicator].use_short_indicator_name &&
              indicators[indicator].shortName !== null
                ? indicators[indicator].shortName
                : indicators[indicator].indicatorName) +
              ".rate"
          ].toString();
      }

      return indicators[indicator].indicatorCode.includes("*") ? rate : text;
    },
    getRateCountValue(comparator, indicator, indicators) {
      // now the values
      let count = "-";
      if (
        this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName)
        ] !== null
      ) {
        count =
          this.indicatorValues[
            this.comparators[comparator] +
              "." +
              indicators[indicator].indicatorCode +
              "." +
              indicators[indicator].date +
              "." +
              (indicators[indicator].use_short_indicator_name &&
              indicators[indicator].shortName !== null
                ? indicators[indicator].shortName
                : indicators[indicator].indicatorName)
          ].toString();
      }
      let rate = "-";
      if (
        typeof this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName) +
            ".rate"
        ] !== "undefined" &&
        this.indicatorValues[
          this.comparators[comparator] +
            "." +
            indicators[indicator].indicatorCode +
            "." +
            indicators[indicator].date +
            "." +
            (indicators[indicator].use_short_indicator_name &&
            indicators[indicator].shortName !== null
              ? indicators[indicator].shortName
              : indicators[indicator].indicatorName) +
            ".rate"
        ] !== null
      ) {
        rate =
          this.indicatorValues[
            this.comparators[comparator] +
              "." +
              indicators[indicator].indicatorCode +
              "." +
              indicators[indicator].date +
              "." +
              (indicators[indicator].use_short_indicator_name &&
              indicators[indicator].shortName !== null
                ? indicators[indicator].shortName
                : indicators[indicator].indicatorName) +
              ".rate"
          ].toString();
      }

      return {
        count: count,
        rate: rate,
      };
    },
    buildReport() {
      // set the scaffolding
      this.wordDocument = {
        creator: "Oxford Consultants for Social Inclusion",
        title:
          this.$store.state.reportType == "Summary"
            ? "Local Insight Summary Report"
            : this.content.reportTitle,
        description:
          this.$store.state.reportType == "Summary"
            ? "Local Insight Summary Report"
            : this.content.description,
        font: "Open Sans",
        features: {
          updateFields: false,
        },
        styles: {
          default: {
            title: {
              run: {
                size: 52,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            heading1: {
              id: "heading1",
              name: "Heading 1",
              run: {
                size: 40,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            heading2: {
              id: "heading2",
              name: "Heading 2",
              run: {
                size: 32,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            heading3: {
              id: "heading3",
              name: "Heading 3",
              run: {
                size: 28,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            heading4: {
              id: "heading4",
              name: "Heading 4",
              run: {
                size: 26,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            heading5: {
              id: "heading5",
              name: "Heading 5",
              run: {
                size: 32,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
          },
          paragraphStyles: [
            // ---- TITLE ----
            {
              id: "Title",
              name: "Title",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 52, // 26 pt  (value is half-points)
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
              paragraph: { spacing: { after: 240 } },
            },

            // ---- HEADING 1 ----
            {
              id: "Heading1",
              name: "Heading 1",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 40, // 20 pt
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
            },

            // ---- HEADING 2 ----
            {
              id: "Heading2",
              name: "Heading 2",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 32, // 16 pt
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
            },

            // ---- HEADING 3 ----
            {
              id: "Heading3",
              name: "Heading 3",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 28, // 14 pt
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
            },

            // ---- HEADING 4 ----
            {
              id: "Heading4",
              name: "Heading 4",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 26, // 13 pt
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
            },

            // ---- HEADING 5 ----
            {
              id: "Heading5",
              name: "Heading 5",
              basedOn: "Normal",
              next: "Normal",
              quickFormat: true,
              run: {
                size: 32,
                bold: false,
                italics: false,
                color: "51627C",
                font: "Nunito",
              },
            },
            {
              id: "subtitle",
              name: "Subtitle",
              run: {
                size: 40,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            {
              id: "normal",
              name: "Normal  ",
              run: {
                size: 40,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            {
              id: "normalsml",
              name: "Normal ",
              run: {
                size: 26,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
            },
            {
              id: "tableHeader",
              name: "Table Header",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "000000",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 25,
                  after: 25,
                },
              },
            },
            {
              id: "rateAndCountHeader",
              name: "Rate And Count Header",
              run: {
                size: 24,
                bold: true,
                italics: false,
                color: "262729",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 25,
                  after: 25,
                },
              },
            },
            {
              id: "tableData",
              name: "Table Data",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "262729",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 50,
                  after: 50,
                },
              },
            },
            {
              id: "bodyText",
              name: "Body Text",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "262729",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 50,
                  after: 50,
                },
              },
            },
            {
              id: "contentsList",
              name: "Contents List",
              run: {
                size: 26,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 50,
                  after: 50,
                },
              },
            },
            {
              id: "bullets",
              name: "Bullet Points",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "262729",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 50,
                  after: 50,
                },
              },
            },
            {
              id: "footerText",
              name: "Footer Text",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "262729",
                font: "nunito",
              },
              paragraph: {
                spacing: {
                  before: 50,
                  after: 50,
                },
              },
            },
            {
              id: "tableAndGraphFooterAndHeaderText",
              name: "Table And Graph Footer And Header Text",
              run: {
                size: 24,
                bold: false,
                italics: false,
                color: "262729",
                font: "nunito",
              },
            },
            {
              id: "disclaimer",
              name: "Disclaimer",
              run: {
                size: 24,
                color: "#7F7F7F",
                font: "nunito",
              },
            },
          ],
        },
        sections: [],
      };
      // call this
      this.reSizeCharts(this.chartsWidth + "px", this.chartsHeight + "px");
      // slight delay whilst charts finish re-sizing
      setTimeout(
        function () {
          this.insertThemes();
          this.sendAnalytics();
        }.bind(this),
        2000,
      );
    },
    reSizeCharts(w, h) {
      for (let i = 0; i < this.content.themes.length; i++) {
        for (let j = 0; j < this.content.themes[i].config.length; j++) {
          // if this is a chart?
          if (this.content.themes[i].config[j].chartRef) {
            // re-size it's container
            document.getElementById(
              "chartContainer_" + this.content.themes[i].config[j].chartRef,
            ).style.width = w;
            document.getElementById(
              "chartContainer_" + this.content.themes[i].config[j].chartRef,
            ).style.height = h;
          }
        }
      }
    },
    revertSizeCharts() {
      const isFullScreenViewMode =
        this.$store.state.config.userProfile.full_screen_report_view;

      const fixedWidthRules = {
        "Horizontal Bar": this.screenWidth > 800 ? "800px" : "96vw",
        Pyramid: this.screenWidth > 800 ? "1200px" : "96vw",
        "Stacked Bar": this.screenWidth > 800 ? "800px" : "96vw",
        Line: this.screenWidth > 1400 ? "1400px" : "96vw",
      };

      this.content.themes.forEach((theme) => {
        theme.config.forEach((config) => {
          if (config.chartRef) {
            let width = "";
            let height = "";

            if (!isFullScreenViewMode) {
              const chartType = config.chartType;

              // Set width for Bar charts based on the number of indicators
              if (chartType === "Bar") {
                const datasetCount = config?.indicators?.length || 0;
                width = ["720px", "870px", "1020px", "1400px"][
                  Math.min(datasetCount, 4) - 1
                ];

                width = this.screenWidth > parseInt(width) ? width : "96vw";
              }

              // If width is still unset, use the width guide for other chart types
              width = width || fixedWidthRules[chartType];
            }

            // Apply width and height to the chart container
            const chartContainer = document.getElementById(
              "chartContainer_" + config.chartRef,
            );
            chartContainer.style.width = width || "96vw";
            chartContainer.style.height = height || "60vh";
          }
        });
      });
    },
    insertThemes() {
      for (var i = 0; i < this.content.themes.length; i++) {
        // add new section (page / theme) to word document
        this.wordDocument.sections.push(this.$cloneDeep(this.sectionTemplate));
        // add theme header
        if (this.content.themes[i].title === null) {
          // eslint-disable-next-line vue/no-mutating-props
          this.content.themes[i].title = "No Title";
        }
        let themeHeader = new Paragraph({
          heading: HeadingLevel.HEADING_1,
          children: [
            new Bookmark({
              id: "theme_section_" + i,
              children: [new TextRun(this.content.themes[i].title)],
            }),
          ],
        });
        // add it to the word document
        this.wordDocument.sections[i].children.push(themeHeader);

        if (this.content.themes[i].description !== null) {
          this.insertText(this.content.themes[i].description, "bodyText", i);
        }
        // gimme some space!
        this.addSpacerParagraph(i, 200);
        // now lets insert the content for this theme
        for (var j = 0; j < this.content.themes[i].config.length; j++) {
          // if just text
          if (this.content.themes[i].config[j].text) {
            this.insertText(
              this.content.themes[i].config[j].text,
              "bodyText",
              i,
            );
          }
          // if a KPI
          if (
            typeof this.content.themes[i].config[j].kpi_config !== "undefined"
          ) {
            if (this.content.themes[i].config[j].kpi_config !== null) {
              // call this function
              this.addKPIBoxes(i, this.content.themes[i].config[j].kpi_config);
            }
          }
          // if this is a chart
          if (this.content.themes[i].config[j].chartRef) {
            // insert chart image into report
            this.addChartToReport(
              document
                .querySelector(
                  'canvas[chart-id="' +
                    this.content.themes[i].config[j].chartRef +
                    '"]',
                )
                .toDataURL("image/png", 1.0)
                .replace(/^data:image\/(png|jpg);base64,/, ""),
              i,
              this.content.themes[i].config[j].itemName,
              this.content.themes[i].config[j].itemSource,
            );
          }
          // if this is a table
          if (
            this.content.themes[i].config[j].indicatorHTMLTableRef &&
            !this.content.themes[i].config[j].text
          ) {
            // get the indicators
            let indicators = [];
            for (
              var k = 0;
              k < this.content.themes[i].config[j].indicators.length;
              k++
            ) {
              if (
                this.content.themes[i].config[j].indicators[k]
                  .indicatorHTMLTableRef
              ) {
                indicators.push(this.content.themes[i].config[j].indicators[k]);
              }
            }
            // standard
            if (this.content.themes[i].config[j].HTMLTableType === 1) {
              this.addStandaredTable(
                i,
                indicators,
                this.content.themes[i].config[j].itemName,
                this.content.themes[i].config[j].itemSource,
              );
            }
            // Rate and Count
            if (this.content.themes[i].config[j].HTMLTableType === 2) {
              this.addRateAndCountTable(
                i,
                indicators,
                this.content.themes[i].config[j].itemName,
                this.content.themes[i].config[j].itemSource,
              );
            }
            // Domain
            if (this.content.themes[i].config[j].HTMLTableType === 3) {
              this.addDomainTable(
                i,
                indicators,
                this.content.themes[i].config[j].domainHTMLTableColOneText,
                this.content.themes[i].config[j].domainHTMLTableColTwoText,
                this.content.themes[i].config[j].itemName,
                this.content.themes[i].config[j].itemSource,
              );
            }
          }
          // gimme some space (if not last item in final theme i.e. end of report)!
          if (
            i !== this.content.themes.length - 1 ||
            j !== this.content.themes[i].config.length - 1
          ) {
            this.addSpacerParagraph(i, 400);
          }
        }
      }
      // now call this
      this.generateContentsPage();
    },
    // add kpi box(es)
    addKPIBoxes(index, KPIConfig) {
      // add each card
      var columnWidths = [];
      var tableRows = [];
      var cards = [];
      const totalCells = KPIConfig.length;
      const spacing = totalCells > 1 ? convertInchesToTwip(0.125) : 0;

      for (var i = 0; i < KPIConfig.length; i++) {
        columnWidths.push(Math.abs(this.tableWidth / KPIConfig.length));
        cards.push(
          // kpi card
          new TableCell({
            children: [
              new Table({
                width: {
                  size: Math.abs(this.tableWidth / KPIConfig.length),
                  type: WidthType.DXA,
                },
                rows: [
                  // kpi card header
                  new TableRow({
                    children: [
                      new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: {
                          size: Math.abs(this.tableWidth / KPIConfig.length),
                          type: WidthType.DXA,
                        },
                        columnSpan: totalCells === 1 ? 2 : totalCells,
                        children: [
                          new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                              new TextRun({
                                text: KPIConfig[i].header,
                                size: 26,
                                bold: false,
                                italics: false,
                                color: "4D4D4D",
                                font: "nunito",
                              }),
                            ],
                          }),
                        ],
                        cantSplit: true,
                        borders: {
                          top: {
                            style: BorderStyle.THICK,
                            size: 3,
                            color: "51627C",
                          },
                          right: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          left: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: "ffffff",
                          },
                        },
                        margins: {
                          top: convertInchesToTwip(0.1),
                          bottom: convertInchesToTwip(0.1),
                          left: convertInchesToTwip(0.1),
                          right: convertInchesToTwip(0.1),
                        },
                      }),
                    ],
                    cantSplit: true,
                    height: {
                      value: 650,
                      rule: HeightRule.ATLEAST, // Use HeightRule.EXACT or HeightRule.ATLEAST
                    },
                  }),
                  // kpi card body
                  new TableRow({
                    children: [
                      new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: {
                          size: Math.abs(this.tableWidth / KPIConfig.length),
                          type: WidthType.DXA,
                        },
                        columnSpan: totalCells === 1 ? 2 : totalCells,
                        children: [
                          new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                              new TextRun({
                                text: KPIConfig[i].body,
                                size: 40,
                                bold: true,
                                italics: false,
                                color: "51627C",
                                font: "nunito",
                                spacing: {
                                  before: 0,
                                  after: 0,
                                },
                              }),
                            ],
                          }),
                        ],
                        cantSplit: true,
                        borders: {
                          top: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: "#000000",
                          },
                          right: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          left: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 0,
                            color: "#000000",
                          },
                        },
                        margins: {
                          top: convertInchesToTwip(0.1),
                          bottom: convertInchesToTwip(0.1),
                          left: convertInchesToTwip(0.1),
                          right: convertInchesToTwip(0.1),
                        },
                      }),
                    ],
                    cantSplit: true,
                    height: {
                      value: 790,
                      rule: HeightRule.ATLEAST, // Use HeightRule.EXACT or HeightRule.ATLEAST
                    },
                  }),
                  // kpi card footer
                  new TableRow({
                    children: [
                      new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: {
                          size: Math.abs(this.tableWidth / KPIConfig.length),
                          type: WidthType.DXA,
                        },
                        columnSpan: totalCells === 1 ? 2 : totalCells,
                        children: [
                          new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                              new TextRun({
                                text: KPIConfig[i].footer,
                                size: 22,
                                bold: false,
                                italics: false,
                                color: "7F7F7F",
                                font: "nunito",
                              }),
                            ],
                          }),
                        ],
                        cantSplit: true,
                        borders: {
                          top: {
                            style: BorderStyle.THICK,
                            size: 1,
                            color: "#e8dfdf",
                          },
                          right: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          left: {
                            style: BorderStyle.THICK,
                            size: 4,
                            color: "51627C",
                          },
                          bottom: {
                            style: BorderStyle.THICK,
                            size: 3,
                            color: "51627C",
                          },
                        },
                        margins: {
                          top: convertInchesToTwip(0.1),
                          bottom: convertInchesToTwip(0.1),
                          left: convertInchesToTwip(0.1),
                          right: convertInchesToTwip(0.1),
                        },
                      }),
                    ],
                    cantSplit: true,
                    height: {
                      value: 870,
                      rule: HeightRule.ATLEAST, // Use HeightRule.EXACT or HeightRule.ATLEAST
                    },
                  }),
                ],
                cantSplit: true,
              }),
            ],
            cantSplit: true,
            margins: {
              top: convertInchesToTwip(0.0),
              bottom: convertInchesToTwip(0.0),
              left: spacing / 2,
              right: spacing / 2,
            },
            borders: this.noCellBorders,
          }),
        );
      }
      // the actual cards
      tableRows.push(
        new TableRow({
          children: cards,
          cantSplit: true,
        }),
      );
      // kpi card(s) source
      if (
        KPIConfig[0].source !== null &&
        KPIConfig[0].source !== "" &&
        KPIConfig[0].source !== "null"
      ) {
        tableRows.push(
          this.generateTableAndGraphFooter(
            totalCells,
            KPIConfig[0].source,
            true,
          ),
        );
      }
      // the kpi card(s) container
      const containerTable = new Table({
        width: {
          size: Math.abs(this.tableWidth),
          type: WidthType.DXA,
        },
        columnWidths: columnWidths,
        rows: tableRows,
        cantSplit: true,
      });
      // add kpi container to the word document
      this.wordDocument.sections[index].children.push(containerTable);
    },
    // Domain Table
    addDomainTable(
      index,
      indicators,
      domainHTMLTableColOneText,
      domainHTMLTableColTwoText,
      itemName,
      itemSource,
    ) {
      // generate the table header
      var tableRows = [this.generateTableAndGraphHeader(8, itemName)];

      // first we will build the indicator and explanatory text headers
      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              columnSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Indicator")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              columnSpan: 3,
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText(domainHTMLTableColOneText)],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              columnSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Indicator")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              columnSpan: 3,
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText(domainHTMLTableColTwoText)],
            }),
          ],
        }),
      );

      // now add the comparators
      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph("")], // intentionally blank
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[0]),
                  "rateAndCountHeader",
                ),
              ],
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[1]),
                  "rateAndCountHeader",
                ),
              ],
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[2]),
                  "rateAndCountHeader",
                ),
              ],
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [new Paragraph("")], // intentionally blank
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[0]),
                  "rateAndCountHeader",
                ),
              ],
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[2]),
                  "rateAndCountHeader",
                ),
              ],
            }),
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(
                  this.comparitorName(this.comparators[2]),
                  "rateAndCountHeader",
                ),
              ],
            }),
          ],
        }),
      );

      // now add the indicators and their values
      for (var i = 0; i < indicators.length / 2; i++) {
        var lastRow = i == indicators.length / 2 - 1;

        tableRows.push(
          new TableRow({
            tableHeader: true,
            children: [
              new TableCell({
                margins: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 100,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text:
                      (indicators[i].use_short_indicator_name &&
                      indicators[i].shortName !== null
                        ? indicators[i].shortName
                        : indicators[i].indicatorName) +
                      (indicators[i].concatenate_dates
                        ? " (" + indicators[i].dateCoverageText + ")"
                        : ""),
                    style: "tableData",
                    alignment: AlignmentType.LEFT,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(indicators[i])[0],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(indicators[i])[1],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(indicators[i])[2],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              // RHC
              new TableCell({
                margins: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 100,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text:
                      indicators[i + indicators.length / 2]
                        .use_short_indicator_name &&
                      indicators[i + indicators.length / 2].shortName !== null
                        ? indicators[i + indicators.length / 2].shortName
                        : indicators[i + indicators.length / 2].indicatorName,
                    style: "tableData",
                    alignment: AlignmentType.LEFT,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(
                      indicators[i + indicators.length / 2],
                    )[0],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(
                      indicators[i + indicators.length / 2],
                    )[1],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.buildValueCells(
                      indicators[i + indicators.length / 2],
                    )[2],
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
            ],
          }),
        );
      }
      // generate and add the table footer
      tableRows.push(this.generateTableAndGraphFooter(8, itemSource));

      // build the table
      const table = new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        columnWidths: [
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
          this.tableWidth / 8,
        ],
        rows: tableRows,
      });

      // add it to the word document
      this.wordDocument.sections[index].children.push(table);
    },
    // this is used in the domain type table
    buildValueCells(indicator) {
      // build comparators header cells
      var cellValues = [];
      for (var i = 0; i < this.comparators.length; i++) {
        let text = "-";
        if (
          this.indicatorValues[
            this.comparators[i] +
              "." +
              indicator.indicatorCode +
              "." +
              indicator.date +
              "." +
              indicator.indicatorName
          ] !== null
        ) {
          text =
            this.indicatorValues[
              this.comparators[i] +
                "." +
                indicator.indicatorCode +
                "." +
                indicator.date +
                "." +
                indicator.indicatorName
            ].toString();
        }
        cellValues.push(text);
      }
      return cellValues;
    },
    // Rate and Count table
    addRateAndCountTable(index, indicators, itemName, itemSource) {
      // set the table header
      var tableRows = [this.generateTableAndGraphHeader(7, itemName)];

      // first we will build the locations/comparators row and then the Rate and Count columns...then add the data afterwards
      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              width: { size: 25, type: WidthType.PERCENTAGE },
              columnSpan: 1,
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Indicator")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              width: { size: 25, type: WidthType.PERCENTAGE },
              columnSpan: 2,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[0])),
              ],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              width: { size: 25, type: WidthType.PERCENTAGE },
              columnSpan: 2,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[1])),
              ],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              width: { size: 25, type: WidthType.PERCENTAGE },
              columnSpan: 2,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[2])),
              ],
            }),
          ],
        }),
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              width: { size: 25, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Count", "rateAndCountHeader")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Rate", "rateAndCountHeader")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Count", "rateAndCountHeader")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Rate", "rateAndCountHeader")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Count", "rateAndCountHeader")],
            }),
            new TableCell({
              width: { size: 12.5, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Rate", "rateAndCountHeader")],
            }),
          ],
        }),
      );

      // next we build the rows with indicator name and their values
      for (let i = 0; i < indicators.length; i++) {
        var lastRow = i == indicators.length - 1;

        tableRows.push(
          new TableRow({
            children: [
              new TableCell({
                width: { size: 25, type: WidthType.PERCENTAGE },
                margins: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 100,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text:
                      (indicators[i].use_short_indicator_name &&
                      indicators[i].shortName !== null
                        ? indicators[i].shortName
                        : indicators[i].indicatorName) +
                      (indicators[i].concatenate_dates
                        ? " (" + indicators[i].dateCoverageText + ")"
                        : ""),
                    style: "tableData",
                    alignment: AlignmentType.LEFT,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(0, i, indicators).count,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(0, i, indicators).rate,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(1, i, indicators).count,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(1, i, indicators).rate,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(2, i, indicators).count,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                width: { size: 12.5, type: WidthType.PERCENTAGE },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text: this.getRateCountValue(2, i, indicators).rate,
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
            ],
          }),
        );
      }
      // generate and add the table footer
      tableRows.push(this.generateTableAndGraphFooter(7, itemSource));

      // build the table
      const table = new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        // we have to add columnWidths so google docs / web previews can size the table properly
        columnWidths: [
          this.tableWidth / 7,
          this.tableWidth / 7,
          this.tableWidth / 7,
          this.tableWidth / 7,
          this.tableWidth / 7,
          this.tableWidth / 7,
          this.tableWidth / 7,
        ],
        rows: tableRows,
      });

      // add it to the word document
      this.wordDocument.sections[index].children.push(table);
    },
    // standard table
    addStandaredTable(index, indicators, itemName, itemSource) {
      // set the table header
      var tableRows = [this.generateTableAndGraphHeader(4, itemName)];

      // first we will build the locations/comparators row and then the Rate and Count columns...then add the data afterwards
      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Indicator")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[0])),
              ],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[1])),
              ],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [
                this.columnHeaderText(this.comparitorName(this.comparators[2])),
              ],
            }),
          ],
        }),
      );
      // add the rows with indicator name and their values
      for (let i = 0; i < indicators.length; i++) {
        var lastRow = i == indicators.length - 1;

        tableRows.push(
          new TableRow({
            children: [
              new TableCell({
                margins: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 100,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow, //prevent table footer being orphaned from last row of table
                    text:
                      (indicators[i].use_short_indicator_name &&
                      indicators[i].shortName !== null
                        ? indicators[i].shortName
                        : indicators[i].indicatorName) +
                      (indicators[i].concatenate_dates
                        ? " (" + indicators[i].dateCoverageText + ")"
                        : ""),
                    style: "tableData",
                    alignment: AlignmentType.LEFT,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.getStandardTableData(0, i, indicators),
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.getStandardTableData(1, i, indicators),
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
              new TableCell({
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    keepNext: lastRow,
                    text: this.getStandardTableData(2, i, indicators),
                    style: "tableData",
                    alignment: AlignmentType.CENTER,
                  }),
                ],
              }),
            ],
          }),
        );
      }
      // generate and add the table footer
      tableRows.push(this.generateTableAndGraphFooter(4, itemSource));

      // build the table
      const table = new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        columnWidths: [
          this.tableWidth / 4,
          this.tableWidth / 4,
          this.tableWidth / 4,
          this.tableWidth / 4,
        ],
        rows: tableRows,
      });

      // add it to the word document
      this.wordDocument.sections[index].children.push(table);
    },
    humanise(str) {
      if (str === "undefined" || str === null) {
        return "";
      }
      var i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags
        .join(" ")
        .replace(/[\u00A0\t\r\n]+/g, " ") // normalise invisible whitespace
        .trim();
    },
    addChartToReport(base64, index, itemName, itemSource) {
      // set the table header
      var tableRows = [this.generateTableAndGraphHeader(1, itemName)];

      /* assume `base64` may or may not carry a data-URL header */
      const chartPayload = base64.replace(/^data:image\/\w+;base64,/, "");

      /* ensure integer pixel sizes (Word dislikes fractions) */
      const chartW = Math.round(this.chartsWidth);
      const chartH = Math.round(this.chartsHeight);

      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              verticalAlign: VerticalAlign.CENTER,
              children: [
                new Paragraph({
                  children: [
                    new ImageRun({
                      type: "png",
                      data: chartPayload,
                      transformation: { width: chartW, height: chartH },
                      altText: {
                        title: "Chart " + this.humanise(itemName),
                        description:
                          "This chart shows " +
                          this.humanise(itemName) +
                          ". A textual description is provided elsewhere in this report.",
                        name: "Chart for " + this.humanise(itemName),
                      },
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      );

      // generate and add the table footer
      tableRows.push(this.generateTableAndGraphFooter(1, itemSource));

      // build the table
      const table = new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        // we have to add columnWidths so google docs / web previews can size the table properly
        columnWidths: [this.tableWidth],
        rows: tableRows,
      });

      // add it to the word document
      this.wordDocument.sections[index].children.push(table);
    },
    comparitorName(comparator) {
      for (var i = 0; i < this.comparatorsList.length; i++) {
        if (this.comparatorsList[i].area_code === comparator) {
          return this.comparatorsList[i].area_name;
        }
      }
    },
    generateTitlePage() {
      // create a time stamp
      this.timeStamp = formatDate(new Date());
      this.wordDocument.sections.unshift(this.$cloneDeep(this.sectionTemplate));
      const table = new Table({
        // rows: 2,
        columns: 2,
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        // we have to add columnWidths so google docs / web previews can size the table properly
        columnWidths: [this.tableWidth / 2, this.tableWidth / 2],
        rows: [
          new TableRow({
            height: { value: 2500, rule: HeightRule.ATLEAST },
            children: [
              new TableCell({
                margins: this.noCellMargins,
                borders: this.noCellBorders,
                verticalAlign: VerticalAlign.TOP,
                children: [
                  new Paragraph({
                    children: [
                      new ImageRun({
                        type: "png", // tell docx the format ↴
                        data: this.topLeftLogo, // raw base-64 payload (no header, no atob)
                        transformation: { width: 213, height: 74 }, // integers only
                        altText: {
                          title: "Local Insight Logo",
                          description: "This is the logo for Local Insight",
                          name: "Local Insight Logo",
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new TableCell({
                borders: this.noCellBorders,
                margins: this.noCellMargins,
                verticalAlign: VerticalAlign.TOP,
                children: [
                  new Paragraph({
                    alignment: AlignmentType.RIGHT,
                    children: [
                      new ImageRun({
                        type: "png",
                        data: this.topRightLogo,
                        transformation: { width: 202, height: 81 },
                        altText: {
                          title: "Company Logo",
                          description:
                            "This is the company logo for Oxford Consultants for Social Inclusion",
                          name: "Company Logo",
                        },
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          new TableRow({
            height: { value: 6000, rule: HeightRule.ATLEAST },
            children: [
              new TableCell({
                borders: this.noCellBorders,
                margins: this.noCellMargins,
                children: [
                  new Paragraph({
                    spacing: {
                      before: 1000,
                      after: 200,
                    },
                    text: this.content.reportTitle,
                    heading: HeadingLevel.TITLE,
                  }),
                  new Paragraph({
                    spacing: {
                      before: 200,
                      after: 200,
                    },
                    text: this.comparitorName(this.comparators[0]),
                    heading: HeadingLevel.HEADING_1,
                  }),
                  new Paragraph({
                    spacing: {
                      before: 200,
                      after: 200,
                    },
                    text:
                      "Created for " +
                      this.content.clientName +
                      " on " +
                      this.timeStamp,
                    heading: HeadingLevel.HEADING_2,
                  }),
                  new Paragraph({
                    style: "disclaimer",
                    spacing: {
                      before: 400,
                      after: 200,
                    },
                    text: `Oxford Consultants for Social Inclusion Ltd. All rights reserved. Copyright ©${new Date().getFullYear()}. This report is provided for public benefit use only and must not be used for commercial purposes.`,
                    color: "#7F7F7F",
                  }),
                ],
              }),
              new TableCell({
                borders: this.noCellBorders,
                margins: this.noCellMargins,
                children: [
                  new Paragraph({
                    alignment: AlignmentType.RIGHT,
                    children: [
                      new ImageRun({
                        type: "png",
                        data: this.mapDataURL.replace(
                          /^data:image\/\w+;base64,/,
                          "",
                        ),
                        transformation: { width: 376, height: 376 },
                        altText: {
                          title: "Map for main comparator",
                          description:
                            "This is a picture of a map which displays the main comparator for this report",
                          name: "Map for main comparator",
                        },
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        ],
      });

      // add this flag so we know its the title page (don't want a footer on it)
      this.wordDocument.sections[0].properties.titlePage = true;

      // add it to the main document
      this.wordDocument.sections[0].children.push(table);

      if (this.includeAppendix) {
        this.generateAppendixPage();
      } else {
        this.serveUpReport();
      }
    },
    insertText(txt, style = "bodyText", index = 0) {
      const isBulletList = txt.includes("<ul>");
      const isOrderedList = txt.includes("<ol>");

      if (isBulletList) {
        this.displayBulletList(txt, style, index);
      } else if (isOrderedList) {
        this.displayOrderedList(txt, style, index);
      } else {
        // just call the paragraph function
        this.displayFormatedText(txt, style, index);
      }
    },
    displayBulletList(txt, style = "bodyText", index = 0) {
      let individualBulletPoints = [];

      txt = txt.split("<ul>");
      for (var i = 0; i < txt.length; i++) {
        if (i === 0) {
          // call the paragraph function
          this.displayFormatedText(txt[i], style, index);
        } else {
          //now get the bullet points
          individualBulletPoints = txt[i].split("</ul>")[0].split("<li>");
          for (var j = 1; j < individualBulletPoints.length; j++) {
            // insert the bullet point
            this.displayFormatedText(
              individualBulletPoints[j].replace("</li>", ""),
              style,
              index,
              true,
            );
          }
          // call the paragraph function
          this.displayFormatedText(txt[i].split("</ul>")[1], style, index);
        }
      }
    },
    displayOrderedList(txt, style = "bodyText", index = 0) {
      ///////////////////// this doesn't work, tell RT NOT to use number bullet points, TODO: will need fixing at some point (Ben 08/03/2024)
      var individualNumberedPoints = [];

      if (txt.split("<ol>").length > 1) {
        txt = txt.split("<ol>");
        for (var i = 0; i < txt.length; i++) {
          if (i === 0) {
            // call the paragraph function
            this.displayFormatedText(txt[i], style, index);
          } else {
            individualNumberedPoints = txt[i].split("</ol>")[0].split("<li>");
            for (var j = 1; j < individualNumberedPoints.length; j++) {
              this.wordDocument.sections[index].children.push(
                // push the ordered item to the word document
                new Paragraph({
                  text: individualNumberedPoints[j]
                    .replace("</li>", "")
                    .replace("&lt;/p&gt;", "")
                    .replace("<p>", "")
                    .replace("</p>", "")
                    .replace(/[\u00A0\t\r\n]+/g, " ")
                    .trim(),
                  numbering: {
                    reference: "my-crazy-numbering",
                    level: 0,
                  },
                  style: {
                    style: style,
                  },
                  spacing: {
                    before: 200,
                  },
                }),
              );
            }
            // call the paragraph function
            this.displayFormatedText(
              txt[i]
                .split("</ol>")[1]
                .replace("</p>", "")
                .replace(/[\u00A0\t\r\n]+/g, " ")
                .trim(),
              style,
              index,
            );
          }
        }
      }
    },
    displayFormatedText(txt, style = "bodyText", index = 0, bullet = false) {
      if (typeof txt !== "undefined") {
        /* check we have paragraphs */
        if (txt.split("<p>").length > 1) {
          txt = this.reduceSpaceUnderneathHeaders(txt);

          txt = txt.split("<p>");

          // loop through each paragraph
          for (var i = 0; i < txt.length; i++) {
            var paragraphStructure = [];
            if (txt[i] !== "") {
              // remove rubbish
              txt[i] = txt[i]
                .replace(/^<p>/, "")
                .replace("<hr>", "")
                .replace("</p>", "")
                .replace(/[\u00A0\t\r\n]+/g, " ")
                .trim();

              let loopCount = 0;
              let endText = txt[i];
              // if there's a link, then split the text and build up the paragraph
              if (endText.includes("<a")) {
                while (endText.includes("<a")) {
                  const startIndex = endText.indexOf("<a");
                  const endIndex = endText.indexOf("</a>") + 4;
                  // get the text before the link
                  const startText = endText.slice(0, startIndex);
                  const linkTag = endText.slice(startIndex, endIndex);
                  const linkMatch = /<a.*?href="(.*?)".*?>(.*?)<\/a>/.exec(
                    linkTag,
                  );

                  if (linkMatch) {
                    // get the link and anchor
                    const link = linkMatch[1];
                    const textLink = linkMatch[2];
                    const endLinkIndex = endText.indexOf("</a>") + 4;
                    const endTextStart = endLinkIndex + 1;
                    const nextLinkStart = endText.indexOf("<a", endLinkIndex);
                    // get text after the link we're dealing with
                    let endTextResult;
                    if (nextLinkStart !== -1) {
                      endTextResult = endText.slice(
                        endTextStart,
                        nextLinkStart,
                      );
                    } else {
                      endTextResult = endText.slice(endTextStart);
                    }
                    endText = endText.slice(endLinkIndex);

                    // apply HTML styles
                    paragraphStructure = this.applyFontStyles(
                      paragraphStructure,
                      startText,
                      endTextResult,
                      link,
                      textLink,
                      loopCount,
                    );

                    loopCount++;
                  } else {
                    break;
                  }
                }
              } else {
                // no links
                paragraphStructure = this.applyFontStyles(
                  paragraphStructure,
                  endText,
                );
              }

              // put all the stuff in a paragraph
              var paragraph;
              if (bullet) {
                paragraph = new Paragraph({
                  spacing: {
                    before: 200,
                    after: 200,
                  },
                  bullet: {
                    level: 0,
                  },
                  style: style,
                  children: [...paragraphStructure],
                });
              } else {
                paragraph = new Paragraph({
                  spacing: {
                    before: 200,
                    after: 200,
                  },
                  style: style,
                  children: [...paragraphStructure],
                });
              }

              // push the paragraph to the word document
              this.wordDocument.sections[index].children.push(paragraph);
            }
          }
        } else {
          this.wordDocument.sections[index].children.push(
            new Paragraph({
              spacing: {
                before: 200,
                after: 200,
              },
              text: txt
                .replace("<p>", "")
                .replace("</p>", "")
                .replace("<p></p>", "")
                .replace("<i>", "")
                .replace("</i>", "")
                .replace("/p>", "")
                .replace("<blockquote>", "")
                .replace("</blockquote>", "")
                .replace("<hr>", "")
                .replace("<br>", "")
                .replace("</br>", "")
                .replace(/[\u00A0\t\r\n]+/g, " ")
                .trim(),
              style: style,
            }),
          );
        }
      }
    },
    applyFontStyles(
      paragraphStructure,
      startText,
      endTextResult = "",
      link = "",
      textLink = "",
      loopCount = 0,
    ) {
      // pick up the right piece of text
      if (loopCount === 0) {
        // apply the HTML styles
        paragraphStructure = this.applyHtml(startText, paragraphStructure);
        // insert a link
        paragraphStructure.push(
          new ExternalHyperlink({
            children: [
              new TextRun({
                text: textLink ? textLink + " " : link,
                style: "Hyperlink",
              }),
            ],
            link: link,
          }),
        );
        // apply the HTML styles to the end of the text
        paragraphStructure = this.applyHtml(endTextResult, paragraphStructure);
      } else {
        paragraphStructure.push(
          new ExternalHyperlink({
            children: [
              new TextRun({
                text: textLink ? textLink + " " : link,
                style: "Hyperlink",
              }),
            ],
            link: link,
          }),
        );
        paragraphStructure = this.applyHtml(endTextResult, paragraphStructure);
      }

      return paragraphStructure;
    },
    applyHtml(text, paragraphStructure) {
      // define the regex
      let regex = /<([^>]+)>(.*?)<\/\1>/g;
      let matches = [];
      let match;

      // remove some rubbish
      text =
        text !== null && text !== undefined
          ? text
              .replace(/<p>/g, "")
              .replace(/<\/p>/g, "")
              .replace(/<i>/g, "")
              .replace(/<\/i>/g, "")
              .replace(/&nbsp;/g, " ")
              .replace(/<\/?span[^>]*>/g, "")
              .replace(/<blockquote>/g, "")
              .replace(/<\/blockquote>/g, "")
              .replace(/<hr>/g, "")
              .replace(/<br>/g, "")
              .replace(/<\/br>/g, "")
              .replace(/<strong>/g, "<b>")
              .replace(/<\/strong>/g, "</b>")
              .replace(/[\u00A0\t\r\n]+/g, " ")
              .trim()
          : "";

      // lets define all HTML tags we have in that piece of text
      while ((match = regex.exec(text)) !== null) {
        let tag = match[1];
        let content = match[2];
        matches.push({ tag: tag, content: content });
      }
      // now we need to apply styles to each tag
      if (matches.length) {
        matches.forEach((item, index) => {
          let tag = item.tag;
          let content = item.content;
          let fullTag = `<${tag}>${content}</${tag}>`;

          // get the beginning of the text and the end of the text
          let textStart = text.split(fullTag)[0];
          let textEnd = text.split(fullTag)[1];

          if (typeof textEnd === "undefined") {
            textEnd = "";
          }

          // insert the beginning of the text
          paragraphStructure.push(
            new TextRun({
              text: textStart,
            }),
          );

          // strike
          if (tag === "s") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                strike: true,
              }),
            );
          }
          // underline
          if (tag === "u") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                underline: {
                  type: UnderlineType.SINGLE,
                },
              }),
            );
          }
          // bold
          if (tag === "b") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                bold: true,
              }),
            );
          }
          // italics
          if (tag === "i" || tag === "em") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                italics: true,
              }),
            );
          }
          // h1
          if (tag === "h1") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 40,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0,
                  after: 0,
                },
              }),
            );
          }
          // h2
          if (tag === "h2") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 32,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0, // Adjust this value to reduce the padding
                  after: 0, // Adjust this value to reduce the padding
                },
              }),
            );
          }
          // h3
          if (tag === "h3") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 28,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0, // Adjust this value to reduce the padding
                  after: 0, // Adjust this value to reduce the padding
                },
              }),
            );
          }
          // h4
          if (tag === "h4") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 26,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0, // Adjust this value to reduce the padding
                  after: 0, // Adjust this value to reduce the padding
                },
              }),
            );
          }
          // h5
          if (tag === "h5") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 24,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0, // Adjust this value to reduce the padding
                  after: 0, // Adjust this value to reduce the padding
                },
              }),
            );
          }
          // h6
          if (tag === "h6") {
            paragraphStructure.push(
              new TextRun({
                text: content,
                size: 22,
                bold: false,
                italics: false,
                color: "51627C",
                font: "nunito",
                spacing: {
                  before: 0, // Adjust this value to reduce the padding
                  after: 0, // Adjust this value to reduce the padding
                },
              }),
            );
          }
          // blockquote
          if (tag === "blockquote") {
            // if it's a block quote, then create a new paragraph
            this.wordDocument.sections[0].children.push(
              new Paragraph({
                style: "bodyText",
                spacing: {
                  before: 0,
                  after: 0,
                },
                children: [...paragraphStructure],
              }),
            );

            // reset the paragraph structure
            paragraphStructure = [];
          }

          // insert the end of the text
          if (index === matches.length - 1) {
            paragraphStructure.push(
              new TextRun({
                text: textEnd
                  .replace("</p>", "")
                  .replace("<", "")
                  .replace("<p></p>", "")
                  .replace(/[\u00A0\t\r\n]+/g, " ")
                  .trim(),
              }),
            );
          }

          // clean up the text for the next iteration
          text = text
            .replace(textStart, "")
            .replace(fullTag, "")
            .replace(/[\u00A0\t\r\n]+/g, " ")
            .trim();
        });
      } else {
        // no styles
        paragraphStructure.push(
          new TextRun({
            text: text
              .replace("<", "")
              .replace(/[\u00A0\t\r\n]+/g, " ")
              .trim(),
          }),
        );
      }

      return paragraphStructure;
    },
    reduceSpaceUnderneathHeaders(txt) {
      // remove empty paragraphs after headers
      const search = [
        "</h1><p></p>",
        "</h2><p></p>",
        "</h3><p></p>",
        "</h4><p></p>",
        "</h5><p></p>",
        "</h6><p></p>",
      ];
      const replace = ["</h1>", "</h2>", "</h3>", "</h4>", "</h5>", "</h6>"];

      for (let i = 0; i < search.length; i++) {
        txt = txt.split(search[i]).join(replace[i]);
      }
      return txt;
    },
    generateExternalSourceLink(
      text,
      style = "tableData",
      shading = {},
      kpi = false,
    ) {
      // declare these
      var link,
        splitText,
        startText,
        endText = null;

      // do we have a link?
      if (text.split("https").length > 1) {
        link = "https" + text.split("https")[1];
        link = link.split(" ")[0].replace(")", "");
        splitText = text.split(link);
        if (splitText.length > 1) {
          startText = splitText[0];
          endText = splitText[1];
        } else {
          startText = splitText[0];
        }
      }
      if (link) {
        return new Paragraph({
          alignment: kpi ? AlignmentType.CENTER : AlignmentType.LEFT,
          spacing: {
            before: 200,
            after: 200,
          },
          style: style,
          shading: shading,
          children: [
            new TextRun({
              text: startText,
            }),
            new ExternalHyperlink({
              children: [
                new TextRun({
                  text: "link",
                  style: "Hyperlink",
                }),
              ],
              link: link,
            }),
            new TextRun({
              text: endText,
            }),
          ],
        });
      } else {
        return new Paragraph({
          alignment: kpi ? AlignmentType.CENTER : AlignmentType.LEFT,
          spacing: {
            before: 200,
            after: 200,
          },
          text: text,
          style: style,
          shading: shading,
        });
      }
    },
    generateIntroPage() {
      this.wordDocument.sections.unshift(this.$cloneDeep(this.sectionTemplate));

      // Introduction
      if (this.content.reportObject.introduction) {
        this.wordDocument.sections[0].children.push(
          new Paragraph({
            spacing: {
              before: 0,
              after: 0,
            },
            text: "Introduction",
            heading: HeadingLevel.HEADING_1,
          }),
        );

        // insert the text using this function
        this.displayFormatedText(this.content.reportObject.introduction);
      }

      // Local Insight
      this.wordDocument.sections[0].children.push(
        new Paragraph({
          spacing: {
            before: 400,
            after: 0,
          },
          text: "Local Insight",
          heading: HeadingLevel.HEADING_2,
        }),
      );

      // insert the text using this function
      this.displayFormatedText(this.content.reportObject.site_branding);

      // OCSI
      this.wordDocument.sections[0].children.push(
        new Paragraph({
          spacing: {
            before: 400,
            after: 0,
          },
          text: "OCSI",
          heading: HeadingLevel.HEADING_2,
        }),
      );

      // insert the text using this function
      this.displayFormatedText(this.content.reportObject.ocsi_branding);

      // About the indicators
      this.wordDocument.sections[0].children.push(
        new Paragraph({
          spacing: {
            before: 400,
            after: 0,
          },
          text: "About the indicators",
          heading: HeadingLevel.HEADING_2,
        }),
      );

      // insert the text using this function
      this.displayFormatedText(this.content.reportObject.about_ind);

      // How we have identified the area “Area A”
      this.wordDocument.sections[0].children.push(
        new Paragraph({
          spacing: {
            before: 400,
            after: 0,
          },
          text:
            "How we have identified the area of " +
            this.comparitorName(this.comparators[0]),
          heading: HeadingLevel.HEADING_2,
        }),
      );

      // insert the text using this function
      this.displayFormatedText(this.content.reportObject.how_area_identified);

      this.generateTitlePage();
    },
    generateContentsPage() {
      this.wordDocument.sections.unshift(this.$cloneDeep(this.sectionTemplate));

      let tableRows = [];

      // Contents
      this.wordDocument.sections[0].children.push(
        new Paragraph({
          spacing: {
            before: 0,
            after: 200,
          },
          text: "Contents",
          heading: HeadingLevel.HEADING_1,
        }),
      );

      // list the themes
      for (let i = 0; i < this.content.themes.length; i++) {
        tableRows.push(
          new TableRow({
            children: [
              new TableCell({
                // width: { size: 100, type: WidthType.PERCENTAGE }, // REMOVE THIS LINE
                borders: this.noCellBorders,
                margins: {
                  top: 100,
                  right: 100,
                  bottom: 100,
                  left: 200,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    style: "contentsList",
                    alignment: AlignmentType.LEFT,
                    children: [
                      new InternalHyperlink({
                        children: [
                          new TextRun({
                            text: this.content.themes[i].title,
                            style: "contentsList",
                          }),
                          // new TextRun(".........................."),
                          // new PageReference("theme_section_" + i),
                        ],
                        anchor: "theme_section_" + i,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        );
      }

      // add the Appendix: Data sources
      if (this.includeAppendix) {
        tableRows.push(
          new TableRow({
            children: [
              new TableCell({
                // width: { size: 100, type: WidthType.PERCENTAGE }, // REMOVE THIS LINE
                borders: this.noCellBorders,
                margins: {
                  top: 100,
                  right: 100,
                  bottom: 100,
                  left: 200,
                },
                verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({
                    style: "contentsList",
                    alignment: AlignmentType.LEFT,
                    children: [
                      new InternalHyperlink({
                        children: [
                          new TextRun({
                            text: "Appendix: Data sources",
                            style: "contentsList",
                          }),
                          // new TextRun(".........................."),
                          // new PageReference("appendix"),
                        ],
                        anchor: "appendix",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        );
      }

      // build the table
      const table = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        columnWidths: [this.tableWidth],
        rows: tableRows,
      });

      // add it to the word document
      this.wordDocument.sections[0].children.push(table);

      // do this next
      this.generateIntroPage();
    },

    generateAppendixPage() {
      // declare these
      const tableRows = [];
      const noRepeats = {};

      // get a new template on the go
      this.wordDocument.sections.push(this.$cloneDeep(this.sectionTemplate));

      // Add the Page Title
      this.wordDocument.sections[
        this.wordDocument.sections.length - 1
      ].children.push(
        new Paragraph({
          spacing: {
            before: 0,
            after: 100,
          },
          heading: HeadingLevel.HEADING_1,
          children: [
            new Bookmark({
              id: "appendix",
              children: [new TextRun("Appendix: Data sources")],
            }),
          ],
        }),
      );

      // Build the table headers
      tableRows.push(
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Theme")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Data")],
            }),
            new TableCell({
              shading: {
                type: ShadingType.SOLID,
                color: "3edbcf",
                fill: "3edbcf",
              },
              verticalAlign: VerticalAlign.CENTER,
              children: [this.columnHeaderText("Data source / time period")],
            }),
          ],
        }),
      );

      // now add the data source rows
      for (var i = 0; i < this.content.themes.length; i++) {
        for (var j = 0; j < this.content.themes[i].config.length; j++) {
          for (
            var k = 0;
            k < this.content.themes[i].config[j].indicators.length;
            k++
          ) {
            if (
              typeof noRepeats[
                this.content.themes[i].config[j].indicators[k].id +
                  "_" +
                  this.content.themes[i].title
              ] === "undefined"
            ) {
              noRepeats[
                this.content.themes[i].config[j].indicators[k].id +
                  "_" +
                  this.content.themes[i].title
              ] = true;
              tableRows.push(
                new TableRow({
                  cantSplit: true,
                  children: [
                    new TableCell({
                      margins: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 100,
                      },
                      verticalAlign: VerticalAlign.CENTER,
                      children: [
                        new Paragraph({
                          text: this.content.themes[i].title,
                          style: "tableData",
                          alignment: AlignmentType.LEFT,
                        }),
                      ],
                    }),
                    new TableCell({
                      margins: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 100,
                      },
                      verticalAlign: VerticalAlign.CENTER,
                      children: [
                        new Paragraph({
                          text: this.content.themes[i].config[j].indicators[k]
                            .indicatorName,
                          style: "tableData",
                          alignment: AlignmentType.LEFT,
                        }),
                      ],
                    }),
                    new TableCell({
                      margins: {
                        top: 100,
                        right: 100,
                        bottom: 100,
                        left: 100,
                      },
                      verticalAlign: VerticalAlign.CENTER,
                      children: [
                        this.generateExternalSourceLink(
                          this.content.themes[i].config[j].indicators[k]
                            .source +
                            " (" +
                            this.content.themes[i].config[j].indicators[k]
                              .dateCoverageText +
                            ")",
                          "tableData",
                          {},
                          false,
                        ),
                      ],
                    }),
                  ],
                }),
              );
            }
          }
        }
      }

      // build the table
      const table = new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
        columnWidths: [
          this.tableWidth / 5,
          this.tableWidth / 2,
          this.tableWidth / 3,
        ],
        rows: tableRows,
      });

      // gimme some space!
      this.addSpacerParagraph(this.wordDocument.sections.length - 1);

      // add it to the word document
      this.wordDocument.sections[
        this.wordDocument.sections.length - 1
      ].children.push(table);

      // now finally serve this god damn report up
      this.serveUpReport();
    },
    generateTableAndGraphHeader(columnSpan, itemName = "") {
      itemName = this.humanise(itemName);
      return new TableRow({
        tableHeader: true,
        height: { value: 600, rule: HeightRule.ATLEAST },
        children: [
          new TableCell({
            width: { size: 100, type: WidthType.PERCENTAGE },
            columnSpan: columnSpan,
            shading: {
              type: ShadingType.SOLID,
              color: "e7e6e6",
              fill: "e7e6e6",
            },
            margins: {
              top: 40,
              right: 0,
              bottom: 0,
              left: 100,
            },
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
              bottom: {
                style: BorderStyle.THICK,
                size: 3,
                color: "000000",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
            },
            children: [
              new Paragraph({
                text: itemName,
                style: "tableAndGraphFooterAndHeaderText",
                shading: {
                  type: ShadingType.SOLID,
                  color: "e7e6e6",
                  fill: "e7e6e6",
                },
              }),
            ],
          }),
        ],
      });
    },
    generateTableAndGraphFooter(columnSpan, itemSource = "", kpi = false) {
      // itemSource = this.generateExternalSourceLink(itemSource);
      return new TableRow({
        children: [
          new TableCell({
            // width: { size: 100, type: WidthType.PERCENTAGE }, // REMOVE THIS LINE
            columnSpan: columnSpan,
            shading: {
              type: ShadingType.SOLID,
              color: kpi ? "ffffff" : "e7e6e6",
              fill: kpi ? "ffffff" : "e7e6e6",
            },
            margins: {
              top: 30,
              right: 0,
              bottom: 40,
              left: 100,
            },
            borders: {
              top: {
                style: kpi ? BorderStyle.NONE : BorderStyle.THICK,
                size: kpi ? 0 : 3,
                color: "000000",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "000000",
              },
            },
            children: [
              this.generateExternalSourceLink(
                "Source: " + itemSource,
                "tableAndGraphFooterAndHeaderText",
                {
                  type: ShadingType.SOLID,
                  color: kpi ? "ffffff" : "e7e6e6",
                  fill: kpi ? "ffffff" : "e7e6e6",
                },
                kpi,
              ),
            ],
            cantSplit: true,
          }),
        ],
        cantSplit: true,
      });
    },
    serveUpReport() {
      this.wordDocument = new Document(this.wordDocument);
      // just set up the config for the numbering
      const doc = new Document({
        numbering: {
          config: [
            {
              reference: "my-crazy-numbering",
              levels: [
                {
                  level: 0,
                  format: LevelFormat.DECIMAL,
                  text: "%1",
                  alignment: AlignmentType.START,
                  style: {
                    paragraph: {
                      indent: { right: 2880 },
                    },
                  },
                },
                {
                  level: 1,
                  format: LevelFormat.DECIMAL,
                  text: "%2.",
                  alignment: AlignmentType.START,
                  style: {
                    paragraph: {
                      indent: {
                        left: convertInchesToTwip(0.3),
                        hanging: convertInchesToTwip(0.25),
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
        sections: [
          {
            children: [
              new Paragraph({
                text: "hello",
                numbering: {
                  reference: "my-crazy-numbering",
                  level: 0,
                },
              }),
            ],
          },
        ],
      });

      this.wordDocument.numbering = doc.numbering;

      Packer.toBlob(this.wordDocument).then((blob) => {
        saveAs(blob, this.content.saveFileName + ".docx");
      });
      // reset the chart sizes
      setTimeout(
        function () {
          this.revertSizeCharts();
          this.downloading = false;
        }.bind(this),
        200,
      );
    },
    generateMapDataURL() {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas dimensions to match the image
      canvas.width = 600;
      canvas.height = 600;

      var img = document.getElementById("mapImg");
      img.crossOrigin = "anonymous";
      img.src = this.mapImage;
      img.onload = function () {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        this.mapDataURL = canvas
          .toDataURL("image/png", 1.0)
          .replace(/^data:image\/(png|jpg);base64,/, "");
        this.buildReport();
      }.bind(this);
    },
    //insert an empty paragraph in given section index to provide space
    addSpacerParagraph(sectionIndex, height = 500) {
      this.wordDocument.sections[sectionIndex].children.push(
        new Paragraph({
          spacing: {
            line: 0.5,
            after: height,
          },
        }),
      );
    },
  },
  watch: {
    download: {
      handler() {
        if (this.downloading) {
          // time delay so we can load the spinner and hide what we are up to!
          setTimeout(
            function () {
              if (this.isReportManager === null) {
                // get the sodding map
                this.generateMapDataURL();
              } else {
                this.buildReport();
              }
            }.bind(this),
            4000,
            // 1000,
          );
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.progress {
  position: relative;
  text-align: center;
  top: 20vh;
  width: 30vw;
  left: 35vw;
}
</style>
